import type { Vector3 } from 'three';

export enum ControlsOperation {
    PAN = 'PAN',
    ROTATE = 'ROTATE',
    ZOOM = 'ZOOM',
}

export type TControlMouse = 'WHEEL' | 0 | 1 | 2;

export enum ControlKey {
    CTRL = 'CTRL',
    SHIFT = 'SHIFT',
}

export interface ICameraControls {
    addEventListener(arg0: string, arg1: () => void): unknown;
    addMouseAction(operation: ControlsOperation, mouse: TControlMouse, key?: ControlKey): void;
    dampingFactor: number;
    dispose(): void;
    domElement: HTMLElement | null;
    enableDamping: boolean;
    enablePan: boolean;
    enableRotate: boolean;
    enableZoom: boolean;
    maxDistance: number;
    minDistance: number;
    panSpeed: number;
    removeEventListener(arg0: string, arg1: () => void): unknown;
    removeMouseAction(mouse: TControlMouse, key?: ControlKey): boolean;
    rotateSpeed: number;
    target: Vector3;
    update(): unknown;
    zoomSpeed: number;
}
